import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ConfigConstants, ConfirmationEventSummaryModel } from '@evorait/pace-core';
import { FormArray } from '@angular/forms';

@Component({
    selector: 'pace-confirmation-event-summary',
    templateUrl: './confirmation-event-summary.component.html',
    styleUrls: ['./confirmation-event-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationEventSummaryComponent {
    @Input()
    public model: ConfirmationEventSummaryModel;

    @Input()
    public parentForm: FormArray;

    public showOtherTrainingFocusField = false;

    public onTrainingFocusValueChange(): void {
        this.showOtherTrainingFocusField =
            this.model.trainingFocus.selectedEntry &&
            this.model.trainingFocus.selectedEntry.value === ConfigConstants.trainingFocusOther;

        // If the field is not shown, then we should clear it's contents as well.
        if (!this.showOtherTrainingFocusField) {
            this.model.otherTrainingFocus.value = '';
        }
    }
}
